import { Component, OnInit, ElementRef, ViewChild, Renderer } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-general-invoice-payment',
  templateUrl: './general-invoice-payment.component.html',
  styleUrls: ['./general-invoice-payment.component.css']
})
export class GeneralInvoicePaymentComponent implements OnInit {
    
    @ViewChild("CloseIn",{static:false}) CloseIn: ElementRef;
  constructor(private renderer: Renderer,public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
  VendorList:any;
  GetAllVendor  () {
    this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
        this.VendorList = data.LookupItems;
    });
}
AccountList:any;
GetAccount  () {
    this.lookupService.GetLookupsList('Acc', '').subscribe( (data)=> {
        this.AccountList = data.LookupItems;
        this.AccountList.splice(0, 1);
    });
};
POInvoiceModel = {
    POInvoiceID: 0,
    InvoiceNumber: '',
    InvoiceDate: moment(new Date()).format('DD-MMM-YYYY'),
    InvoiceAmount: 0,
    VendorID: 0,
    Remarks: '',
    VendorName: '',       
    AccID: 0,
    AccName:""

}
Clear  () {
    this.POInvoiceModel.POInvoiceID = 0;
    this.POInvoiceModel.InvoiceNumber = '';
    this.POInvoiceModel.InvoiceDate = moment(new Date()).format('DD-MMM-YYYY');
    this.POInvoiceModel.InvoiceAmount = 0;
    this.POInvoiceModel.VendorID = 0;
    this.POInvoiceModel.Remarks = '';
    this.POInvoiceModel.VendorName = '';
    this.POInvoiceModel.AccID = 0;
    this.POInvoiceModel.AccName = "";
  this.Submitted=false;
}
 ValidateDropdown() {
    return this.POInvoiceModel.VendorID == 0 || this.POInvoiceModel.AccID == 0  || this.POInvoiceModel.InvoiceAmount == 0 || this.POInvoiceModel.InvoiceNumber == '' || this.POInvoiceModel.InvoiceDate == '';
};
onSelectName  ($item) {

    this.POInvoiceModel.AccID = $item.AccID;
    this.POInvoiceModel.AccName = $item.AccName;

}
Submitted = false;
SaveGeneralInvoice  (valid) {
    this.Submitted = true;
  
    if (valid && !this.ValidateDropdown()) {
         this.spinnerService.show();
         
         this.POInvoiceModel.InvoiceDate= this.POInvoiceModel.InvoiceDate=""?"":moment(this.POInvoiceModel.InvoiceDate).format('DD-MMM-YYYY');
                this.stockService.SaveGeneralInvoice(JSON.stringify(this.POInvoiceModel)).subscribe( (data)=> {
                  
                        this.Submitted = false;
                    if (data.webResponse.Status) {
                      this.spinnerService.hide();
                    this.Clear();
                    this.GetAllGeneralInvoice();
                    
                   
                }
                    this.globalHelper.CheckActionStatus(data);
                });
            }
        

    
}
InvoiceViewModel = {
    InvoiceNumber: '',
    VendorName: '',
    InvoiceDate: '',
    InvoiceAmount: 0,
   
    CancelRemarks: '',
    POInvoiceID: 0,
}
ViewInvoiceDetails  (item) {
    this.InvoiceViewModel.POInvoiceID = item.POInvoiceID;
    this.InvoiceViewModel.InvoiceNumber = item.InvoiceNumber;
    this.InvoiceViewModel.VendorName = item.VendorName;
    this.InvoiceViewModel.InvoiceDate = item.InvoiceDate;
    this.InvoiceViewModel.InvoiceAmount = item.InvoiceAmount;
}
ClearInvoiceView  () {
    this.InvoiceViewModel.POInvoiceID = 0;
    this.InvoiceViewModel.InvoiceNumber = '';
    this.InvoiceViewModel.VendorName = '';
    this.InvoiceViewModel.InvoiceDate = '';
    this.InvoiceViewModel.InvoiceAmount = 0;       
    this.InvoiceViewModel.CancelRemarks = '';
}
tmpListener
CancelGeneralInvoice  () {
   
    this.stockService.CancelGeneralInvoice(JSON.stringify(this.InvoiceViewModel)).subscribe( (data)=> {
      
        this.globalHelper.CheckActionStatus(data);
        // this.ClearInvoiceView();
        this.GetAllGeneralInvoice();
        this.CloseIn.nativeElement.click();

        // this.tmpListener = this.renderer.listen(this.CloseIn.nativeElement, 'click',this.btnLogarClick2);
       
          
    });
}
// public btnLogarClick2() {
//     alert('a');
//   }

//   ngOnDestroy() {
//     this.tmpListener();
//     alert('D');
//   }
FilterModel = {
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    VendorID: 0,
}
InvoiceList:any;
GetAllGeneralInvoice  () {
    this.FilterModel.FromDate=this.FilterModel.FromDate=="" &&  this.FilterModel.FromDate==null?"":moment(this.FilterModel.FromDate).format('DD-MMM-YYYY')
    this.FilterModel.ToDate=this.FilterModel.ToDate=="" &&  this.FilterModel.ToDate==null?"":moment(this.FilterModel.ToDate).format('DD-MMM-YYYY')

    this.stockService.GetAllGeneralInvoice(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
        this.InvoiceList = data.InvoiceList;
       
    });
}

  ngOnInit() {
    this.GetAllVendor();      
    this.GetAccount();
    this.GetAllGeneralInvoice();
  }

}
